// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;I am utterly bowed down and brought very low;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;I go about mourning all the day long.<br> </p> </div></div>";
// Exports
module.exports = code;